export default __webpack_public_path__ + "static/media/CTQ_F05_Jumprope2.01030953.mp4";